<template>
    <div>
        <label v-if="label" class="input-label">{{ label }}</label>
        <!-- v-model="screen_data.invoice.invoice_number" -->
        <!-- :class="classes" -->
        <v-text-field
            outlined
            dense
            hide-details
            :class="{ 'low-size-font': is_mobile }"
            
            v-bind="$attrs"
            v-on="$listeners"

            :value="value"    
            @input="$emit('input', $event)"
            :disabled="disabled"
            :readonly="readonly"
            :background-color="background_color"
            :error="error"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'APPTextFieldV2',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        background_color: {
            type: String,
            default: 'white'
        },
        error: {
            type: Boolean,
            default: false
        },
        classes: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapGetters({
            is_mobile: 'is_mobile',
        })
    }
}

</script>

<style scoped>
    .input-label {
        font-size: 14px !important;
        white-space: nowrap;
    }
    .low-size-font ::v-deep input {
        font-size: 12px !important;
        width: fit-content;
    }
</style>
